import request from "@/api/request";

//文章收藏
export function addFeedback(data) {
  return request({
    url: "/api/kp/Feedback/add",
    method: "post",
    data: data,
  });
}
